module.exports = __webpack_public_path__ + "img/pmc-logo.61107e99.png";